import type { AccessPair } from '@/shared/lib'

/** Корзина клиента `/v1/cart/**` — только своя: модификатора ручка не принимает. У менеджера — корзины за клиентов. */
export const CART_ACCESS: AccessPair = { own: 'cart.manage' }
